import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../Icons';
import { useGlobal } from '../../../contexts/Global/context';

import * as S from './styles';

export const LinkCardCustom = ({ link, icons, title, desc, href, onClick }) => {
    const { contrastTheme } = useGlobal();

    return (
        <S.ContainerCard onClick={onClick}>
            <Link to={link} href={href}>
                <S.AlignCard>
                    <S.Icone>
                        <Icon
                            name={icons?.left?.name}
                            type={icons?.left?.type}
                            size={icons?.left?.size || 36}
                            color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                        />
                    </S.Icone>

                    <S.TextAlign>
                        <S.Title>{title}</S.Title>
                        <S.SubTitle>{desc}</S.SubTitle>
                    </S.TextAlign>

                    <S.ArrowRight>
                        <Icon
                            name={icons?.right?.name || 'ArrowRight'}
                            type={icons?.right?.type}
                            size={icons?.right?.size || 20}
                            color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                        />
                    </S.ArrowRight>
                </S.AlignCard>
            </Link>
        </S.ContainerCard>
    );
};
